import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { VgHlsModule } from '../VgHls.Module';
import { SharedModule } from '../../player/shared/Shared.Module';

import { VgConferenceDualHlsService } from './VgConferenceDualHls.Service';
import { VgConferenceDualHlsComponent } from './VgConferenceDualHls.Component';
import { VbDualPlaybackLayoutMenuButtonComponent } from './VbDualPlaybackLayoutMenuButton.Component';
import { VbDualPlaybackContentContainerComponent } from './VbDualPlaybackContentContainer.Component';

const components = [
	VgConferenceDualHlsComponent,
	VbDualPlaybackLayoutMenuButtonComponent,
	VbDualPlaybackContentContainerComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		BsDropdownModule,
		CommonModule,
		VgHlsModule,
		SharedModule,
		TooltipModule
	],
	providers: [
		VgConferenceDualHlsService
	]
})
export class VgConferenceDualHlsModule {}
